import {addClass, removeClass} from "../_vars";

//export const likedCard = () => {
export const likedCard = (elem) => {
    if (typeof elem === "undefined" || elem === null)
        elem = document;


    let likedCounter = 0;
    const cardsLike = elem.querySelectorAll(".card__liked");
    const likedCartHeader = document.querySelector(".header__liked span");

    let likedStorage = localStorage.getItem('liked');

    if (likedStorage !== null) {
        let likedList = JSON.parse(likedStorage);
        likedList.forEach(function (object){
           let likeButton = document
               .querySelector(`[data-target="object_like"][data-type="${object.type}"][data-id="${object.id}"]`);
           if(likeButton){
               addClass(likeButton, "--like");
           }
        });

        likedCounter = likedList.length;
        likedCounter > 0
            ? addClass(likedCartHeader, "--liked")
            : removeClass(likedCartHeader, "--liked");

        likedCartHeader.textContent = likedCounter;
    }

    cardsLike.forEach((btn) => {
        btn.addEventListener("click", () => {

            let elemType = btn.getAttribute('data-type');
            let elemId = btn.getAttribute('data-id');

            let liked = localStorage.getItem('liked');
            if (liked === null) {
                liked = [];
            } else {
                liked = JSON.parse(liked);
            }

            let elemObject = {
                type: elemType,
                id: elemId
            };
            let findObject = liked.findIndex(object => object.id === elemId)

            //liked.push(elemObject);


            if (btn.classList.contains("--like")) {
                likedCounter--;
                removeClass(btn, "--like");
                likedCartHeader.textContent = likedCounter;
                if (findObject !== -1) {
                    liked.splice(findObject, 1)
                    console.log('object remove');
                }
            } else {

                if (findObject === -1) {
                    liked.push(elemObject)
                    console.log('object added');
                }

                likedCounter++;
                addClass(btn, "--like");
                likedCartHeader.textContent = likedCounter;
            }
            likedCounter > 0
                ? addClass(likedCartHeader, "--liked")
                : removeClass(likedCartHeader, "--liked");


            localStorage.setItem('liked', JSON.stringify(liked));

        });
    });
};
